import React from 'react'
import { Route, withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import { Container } from 'typescript-ioc'
import { AppState } from '@halo/stores/app.state'
import { AppService } from '@halo/services/app.service'
import { PreAuth } from '@halo/portals/pre-auth'
import { PostAuth } from '@halo/portals/post-auth'
import { classnames } from '@halo/_utils/classnames'
import { LoadingScreen } from '@halo/components/loading-screen/loading-screen'
import '@halo/style'
import { getPathClassName } from '@halo/_utils/get-path-classname'

@observer
class Halo extends React.Component {
    protected appState: AppState
    protected appService: AppService

    public constructor(props: any) {
        super(props)

        this.appState = Container.get(AppState)
        this.appService = Container.get(AppService)

        this.appService.attachHistoryContainer((this.props as any).history)
    }

    public componentWillUnmount() {
        // Clear the DOM reference to prevent memory leaks
        if (this.appService) {
            this.appService.appContainerRef = null
        }
    }

    public render() {
        const pathClassName = getPathClassName(location.pathname)

        return (
            <div
                ref={(el) => (this.appService.appContainerRef = el)}
                className={classnames('wrapper', pathClassName, {
                    ['authenticated']: this.appState.isAuthenticated,
                    ['sidebar-open']: !this.appState.sidebar.collapsed,
                })}
            >
                <LoadingScreen />
                <Route component={PreAuth} {...this.props} />
                {this.appState.initialized && !this.appState.appIsLoading && (
                    <>
                        <Route component={PostAuth} {...this.props} />
                    </>
                )}
            </div>
        )
    }
}

export default withRouter(Halo)
